import { render, staticRenderFns } from "./Workloads.vue?vue&type=template&id=0580aef6"
import script from "./Workloads.vue?vue&type=script&lang=js"
export * from "./Workloads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports